<template>
<div class="page_shopCenter page_agent">
    <div class="userInfo">
        <div class="user">
            <div class="user_top">
                <div class="user_left">
                    <div class="thumb" v-if="info.userdata">
                        <img :src="info.userdata.thumb? ($publicData.withHttpStart(info.userdata.thumb) ? info.userdata.thumb : imageUrl+info.userdata.thumb) : $publicData.defaultTouxiang" alt />
                    </div>
                    <div class="user_name slh_s">{{ info.name }}</div>
                </div>
                <div class="user_right">余额:￥ <span class="" v-if="info.useraccount">{{ info.useraccount.partner_money ? info.useraccount.partner_money : 0}}</span></div>
            </div>
        </div>
    </div>
    <div class="agent_list">
        <li class="item" @click="goPage('agent-income')">
            <div class="item_l">
                <img :src="publicPath+'statics/images/icon_income.png'" alt="" class="icon">
                <span class="">收入明细</span>
            </div>
        </li>
        <li class="item" @click="goWithdraw('/agent/withdraw')">
            <div class="item_l">
                <img :src="publicPath+'statics/images/icon_tixian.png'" alt="" class="icon">
                <span class="">提现</span>
            </div>
        </li>
        <li class="item" @click="goPage('agent-withdrawList')">
            <div class="item_l tixianlist">
                <img :src="publicPath+'statics/images/icon_tixianlist.png'" alt="" class="icon">
                <span class="">提现明细</span>
            </div>
        </li>
        <li class="item" @click="goPage('bank-index')">
            <div class="item_l bank">
                <img :src="publicPath+'statics/images/icon_bank.png'" alt="" class="icon">
                <span class="">银行卡管理</span>
            </div>
        </li>
    </div>
    <div class="con">
        <!-- 我的商家 -->
        <!-- <div class="list" v-if="tradesmanList">
            <div class="title">
                <span class="title_l">我的商家</span>
                <span class="title_r">查看更多</span>
            </div>
            <ul class="list_con">
                <li class="item" v-for="tradesman in tradesmanList" :key="tradesman.id">
                    <img :src="tradesman.thumb ? tradesman.thumb : $publicData.defaultTouxiang" alt="" class="icon">
                    <div class="txt">{{ tradesman.nickname }}</div>
                </li>
            </ul>
        </div> -->
        <!-- 我的代理商 -->
        <!-- <div class="list" v-if="partner">
            <div class="title">
                <span class="title_l">我的代理商</span>
                <span class="title_r">查看更多</span>
            </div>
            <ul class="list_con">
                <li class="item">
                    <img :src="partner.thumb ? partner.thumb : $publicData.defaultTouxiang" alt="" class="icon">
                    <div class="txt">{{ partner.name }}</div>
                </li>
            </ul>
        </div> -->
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
			token: null,
			tradesmanList: null , // 我的商家
			partner: null, // 我的代理商
        };
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function () {

    },
    methods: {
        getData() {
            var param = {
                token: this.token
            }
            this.$api.my.partnerIndex(param).then(res => {
                if (res.code == 200) {
                    var info = res.result.info
                    console.log(info)
                    this.info = info
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl+'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
					localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login',
                        // query: {
                        //     redirect: this.$router.currentRoute.fullPath
                        // }
                    })
                    return
				}
				this.$router.push({
                    name: name
                })
                console.log(111+name)
                
            }
		},
		// 提现
		goWithdraw(path){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var url = this.$publicData.clientUrl + path + '?price='+(this.info.useraccount.partner_money?this.info.useraccount.partner_money:'0')+'&type=3'
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + path
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                var query = {
                    price: this.info.useraccount.partner_money?this.info.useraccount.partner_money:0,
                    type: 3
                }
                this.$router.push({
                    path: path,
                    query: query
                })
            }
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
